import { createContext, useContext, useState, useEffect, useCallback, type ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

interface AuthState {
  token: string | null
  logout: () => void
}

const AuthContext = createContext<AuthState>({ token: null, logout: () => {} })

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('smm_token'))

  useEffect(() => {
    const handler = () => {
      setToken(localStorage.getItem('smm_token'))
    }
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('smm_token')
    setToken(null)
  }, [])

  return (
    <AuthContext.Provider value={{ token, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function RequireAuth() {
  const { token } = useAuth()
  const location = useLocation()

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
